import { icons } from "constants/icons";

export const Empty = () => {
  return (
    <div className="flex flex-col items-center">
      <img src={icons.empty} alt="empty" />
      <h4 className="text-black/25 text-center font-medium">No Data</h4>
    </div>
  );
};
